import React, { useEffect, useState, useRef } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import { filterCorruptFile, handleFileUploadWithSignedURL } from "../Environment/Asconfig";
import jsPDF from "jspdf";
import RemovePdfModal from "../modals/RemovePdfModal";
import {
  Container,
  DragAndDrop,
  HeaderText,
  IconDiv,
  LeftPane,
  LeftPaneHeader,
  RightPane,
  SupportText,
  UploadText,
  ChatDiv,
  ChatBox,
  ChatText,
  PdfContainer,
  Header,
  Heading,
  ContentDiv,
  ScrollableChat,
  ClearButton,
  OrDivider,
  ErrorText,
} from "./Style";
import PdfViewer from "../../Components/PdfViewer/PdfViewer";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import UploadIcon from "../../assets/upload.svg";
import BackIcon from "../../assets/back-icon.svg";
import CrossIcon from "../../assets/cross-in-square.svg";
import DriveFilePicker from "./DriveFilePicker";
import DriveFileUploader from "./DriveFileUploader";
import SummarizeDriveFilePicker from "./SummarizeDriveFilePicker";
import { toast } from "react-toastify";
import SnackbarAlert from "../Alerts/SnackbarAlert";
import { MAX_FILE_MB, MAX_FILE_SIZE, API_BASE_URL } from "../../constant/constant";

//summarize component

const uploadFileToS3 = async (file) => {
  try {
    const response = await handleFileUploadWithSignedURL(file);
    return response.fileUrl;
  } catch (error) {
    toast.error(error);

  }
};

const formatBlogPostContent = (text) => {
  // Split text by double new lines for paragraphs
  const paragraphs = text
    ?.split(/\n\n+/)
    .map((paragraph, idx) => {
      // Format text with inline styles and handle list items and links
      return paragraph
        .split(/\n/)
        .map((line, idx) => {
          // Apply bold formatting to all occurrences of **bold text**
          line = line?.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

          if (line?.startsWith("**") && line?.endsWith("**")) {
            return `<h3 key=${idx}>${line.slice(2, -2)}</h3>`;
          } else if (line?.startsWith("- ")) {
            return `<li key=${idx}>${line.slice(2)}</li>`;
          } else if (line?.match(/\[([^\]]+)\]\(([^)]+)\)/)) {
            return line?.replace(
              /\[([^\]]+)\]\(([^)]+)\)/g,
              '<a href="$2">$2</a>'
            );
          } else {
            return `<p key=${idx}>${line}</p>`;
          }
        })
        .join("");
    })
    .map((paragraph, idx) => `<div key=${idx}>${paragraph}</div>`)
    .join("");

  return paragraphs?.replace(/(<li>.*?<\/li>)/g, "<ul>$1</ul>");
};

export default function Summarize() {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [showRemoveFileModal, setShowRemoveFileModal] = useState(false);
  const { isSidebarOpen } = useOutletContext();
  const [isDragActive, setIsDragActive] = useState(false);
  const [error, setError] = useState(null);
  const [objectKey, setObjectKey] = useState("");
  const [conversation, setConversation] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false);
  const navigate = useNavigate();
  const scrollableChatRef = useRef(null);
  const [avatarData, setAvatarData] = useState(null);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    setFileName(selectedFile.name);
    if (selectedFile && selectedFile.type === "application/pdf") {
      const isValid = await filterCorruptFile(selectedFile);
      if (!isValid) {
        setError("The selected PDF file is corrupted. Please choose a valid file.");
        toast.error("The selected PDF file is corrupted. Please choose a valid file.");
        return;
      }
      if (selectedFile.size > MAX_FILE_SIZE) {
        setError(`File size exceeds ${MAX_FILE_MB}MB limit.`);
        toast.error(`File size exceeds ${MAX_FILE_MB}MB limit.`);
        return;
      }
      setLoadingFile(true);
      setFile(selectedFile);
      console.log("file", selectedFile);
      const formData = new FormData();
      console.log("1-----", formData);
      formData.append("file", selectedFile);
      formData.append("language", avatarData?.greetingLanguage)

      fetch("https://flowproai.aivoria.nl/summarize", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Response from server:", data);
          setObjectKey(data.model_path);
          setConversation([{ text: data.summary }]);
        })
        .catch((error) => {
          console.error("Error uploading PDF:", error);
        })
        .finally(() => {
          setLoadingFile(false);
        });

      setFile(URL.createObjectURL(selectedFile));
      setError(null);
    } else {
      setError(t("summarizeDoc.errors.invalidPdf"));
      toast.error(t("summarizeDoc.errors.invalidPdf"));
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragActive(false);
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    setIsDragActive(false);
    const selectedFile = event.dataTransfer.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      const isValid = await filterCorruptFile(selectedFile);
      if (!isValid) {
        setError("The selected PDF file is corrupted. Please choose a valid file.");
        toast.error("The selected PDF file is corrupted. Please choose a valid file.");
        return;
      }
      if (selectedFile.size > MAX_FILE_SIZE) {
        setError(`File size exceeds ${MAX_FILE_MB}MB limit.`);
        toast.error(`File size exceeds ${MAX_FILE_MB}MB limit.`);
        return;
      }
      setLoadingFile(true);
      setFile(selectedFile);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("language", avatarData?.greetingLanguage)

      fetch(
        "https://flowproai.aivoria.nl/summarize",
        {
          method: "POST",
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("Response from server:", data);
          setObjectKey(data.model_path);
          setConversation([{ text: data.summary }]);
        })
        .catch((error) => {
          console.error("Error uploading PDF:", error);
        })
        .finally(() => {
          setLoadingFile(false);
        });

      setFile(URL.createObjectURL(selectedFile));
      setError(null);
    } else {
      toast.error(t("summarizeDoc.errors.invalidPdf"));
      setError(t("summarizeDoc.errors.invalidPdf"));
    }
  };

  const handleDownloadPdf = () => {
    const originalFileName = fileName.split(".pdf")[0];
    const summaryFileName = `${originalFileName}_summary.pdf`;
    setLoadingMessage(true);
    let doc = new jsPDF("p", "pt", "a4");
    const htmlContent = conversation
      .map((msg, index) => {
        const formattedText = formatBlogPostContent(msg?.text);
        return `<div style="width:34rem; letter-spacing:0.5px; padding:2rem; font-size:0.7rem">${formattedText}</div>`;
      })
      .join("");

    doc.html(htmlContent, {
      callback: function (pdf) {
        pdf.save(summaryFileName);
        setLoadingMessage(false);
      },
      x: 10,
      y: 10,
    });
  };

  const generateSummaryPdfBlob = async () => {
    const originalFileName = fileName?.split(".pdf")[0] || "document";
    const doc = new jsPDF("p", "pt", "a4");
    const htmlContent = conversation
      .map((msg) => {
        const formattedText = formatBlogPostContent(msg?.text);
        return `<div style="width:34rem; letter-spacing:0.5px; padding:2rem; font-size:0.7rem">${formattedText}</div>`;
      })
      .join("");

    // Convert HTML to PDF (jsPDF html returns Promise)
    await doc.html(htmlContent, {
      x: 10,
      y: 10,
    });

    // Convert to Blob instead of saving directly
    const pdfBlob = doc.output("blob");
    const summaryFileName = `${originalFileName}_summary.pdf`;
    return { pdfBlob, summaryFileName };
  };


  useEffect(() => {
    if (scrollableChatRef.current) {
      scrollableChatRef.current.scrollTop =
        scrollableChatRef.current.scrollHeight;
    }
  }, [conversation]);

  const handleClearMessages = () => {
    setConversation([]);
  };

  const handleRemoveFile = () => {
    setFile(null);
    handleClearMessages();
  };

  const handleShowRemoveFileModal = () => {
    setShowRemoveFileModal(true);
  };

  const handleHideRemoveFileModal = () => {
    setShowRemoveFileModal(false);
  };
  const handleGoogleDriveFiles = async (fileLinks, accessToken) => {
    if (fileLinks.length > 0) {

      const formData = new FormData();

      const selectedFileId = fileLinks[0];

      try {
        const response = await fetch(
          `https://www.googleapis.com/drive/v3/files/${selectedFileId}?fields=name`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log("response from Google Drive API", response)
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Metadata fetch error:", errorData);
          if (response.status === 404) {
            toast.error(t("summarizeDoc.errors.fileNotFound"));
            setLoadingFile(false);
            return;
          }
          throw new Error(`Metadata error: ${response.statusText}`);
        }
        const fileMetadata = await response.json();
        const fetchedFileName = fileMetadata.name; // Get the filename from metadata
        setFileName(fetchedFileName); // Set the filename state

        // Fetch the PDF file
        const pdfBlob = await fetch(
          `https://www.googleapis.com/drive/v3/files/${selectedFileId}?alt=media&key=${apiKey}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        ).then((response) => response.blob());

        formData.append("file", pdfBlob, fetchedFileName); // Append blob with fetched filename
        formData.append("language", avatarData?.greetingLanguage)
        setLoadingFile(true);

        fetch("https://flowproai.aivoria.nl/summarize", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            setObjectKey(data.model_path);
            setConversation([{ text: data.summary }]);
          })
          .catch((error) => {
            console.error("Error uploading PDF:", error);
          })
          .finally(() => {
            setLoadingFile(false);
          });

        setFile(URL.createObjectURL(pdfBlob));
        setError(null);
      } catch (error) {
        console.error("Error fetching file:", error);
        setLoadingFile(false);
      }
    }
  };

  const getAvatarData = async () => {
    try {
      const userId = localStorage.getItem("id");
      const response = await fetch(
        `${API_BASE_URL}/api/auth/get-avatar?user_id=${userId}`
      );
      const data = await response.json();
      if (data.responseCode === 404) {
        navigate("/avatar-selection");
        return;
      }

      if (data.responseCode === 200) {
        setAvatarData(data.avatar);
      }
    } catch (error) {
      console.error("Error fetching avatar data:", error);
    }
  };
  useEffect(() => {
    getAvatarData();
  }, [])

  return (
    <Container isOpen={isSidebarOpen}>
      <Header
        style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
        onClick={() => navigate("/")}
      >
        <img src={BackIcon} alt={t("summarizeDoc.back")} />

        <Heading style={{ marginBottom: 0 }}>
          {t("summarizeDoc.title")}
        </Heading>

        <Tooltip
          title={t("summarizeDoc.tooltip")}
          placement="top"
        >
          <InfoCircleOutlined
            style={{
              fontSize: 14,
              color: "#8c8c8c",
              cursor: "pointer",
            }}
            onClick={(e) => e.stopPropagation()} // prevent back navigation
          />
        </Tooltip>
      </Header>

      <ContentDiv>
        <LeftPane>
          <div style={{ display: "flex", gap: "20px", marginBottom: "0.5rem" }}>
            <LeftPaneHeader style={{ width: "100%" }}>
              <HeaderText>{t("summarizeDoc.summary")}</HeaderText>
            </LeftPaneHeader>
            {conversation.length > 0 && (
              <>
                <ClearButton
                  onClick={handleDownloadPdf}
                  disabled={loadingMessage}
                >
                  {loadingMessage ? <CircularProgress size={24} /> : t("summarizeDoc.download")}
                </ClearButton>
                <DriveFileUploader
                  onPrepareFile={generateSummaryPdfBlob} // 👈 new prop to dynamically get summary PDF
                  onUploadComplete={() => (
                    <SnackbarAlert
                      message={t("summarizeDoc.uploadSuccess")}
                      severity="success"
                      autoHideDuration={3000}
                    ></SnackbarAlert>
                  )}
                />

              </>
            )}
          </div>
          <ScrollableChat ref={scrollableChatRef}>
            {loadingFile ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
                <ChatText style={{ marginLeft: "1rem" }}>
                  {t("summarizeDoc.summarizingWait")}
                </ChatText>
              </div>
            ) : file ? (
              conversation.map((msg, index) => (
                <ChatDiv key={index}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <ChatBox>
                      <ChatText
                        dangerouslySetInnerHTML={{
                          __html: formatBlogPostContent(msg?.text),
                        }}
                      />
                    </ChatBox>
                  </div>
                </ChatDiv>
              ))
            ) : null}
          </ScrollableChat>
        </LeftPane>
        <RightPane>
          {file ? (
            <PdfContainer>
              <PdfViewer file={file} />
              <img
                src={CrossIcon}
                alt="close"
                style={{
                  position: "absolute",
                  zIndex: "1000",
                  right: "5px",
                  top: "5px",
                  cursor: "pointer",
                  borderRadius: "50%",
                  opacity: "0.6",
                }}
                onClick={handleShowRemoveFileModal} // Show the modal on click
              />
            </PdfContainer>
          ) : (
            <>
              <DragAndDrop
                onClick={() => document.getElementById("fileInput").click()}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                style={isDragActive ? {
                  background: '#e0e7ff',
                  border: '2px dashed #51307F',
                  color: '#51307F',
                  transition: 'background 0.2s, border 0.2s',
                } : {}}
              >
                <input
                  id="fileInput"
                  type="file"
                  accept="application/pdf"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <IconDiv>
                  <img src={UploadIcon} alt="upload" />
                </IconDiv>
                <UploadText>
                  {isDragActive ? (
                    <span style={{ color: '#51307F', fontWeight: 'bold' }}>{t("summarizeDoc.releaseToUpload")}</span>
                  ) : (
                    <>
                      {t("summarizeDoc.dragAndDrop")}
                      <span style={{ color: "#51307F" }}> {t("summarizeDoc.browse")}</span>
                    </>
                  )}
                </UploadText>
                <SupportText>{t("summarizeDoc.supportPdfFiles")}</SupportText>
                {error && <ErrorText>{error}</ErrorText>}
              </DragAndDrop>
              <OrDivider>{t("summarizeDoc.or")}</OrDivider>
              <SummarizeDriveFilePicker
                onFilesSelected={handleGoogleDriveFiles}
              />
            </>
          )}
        </RightPane>
      </ContentDiv>
      {showRemoveFileModal && (
        <RemovePdfModal
          onCancel={handleHideRemoveFileModal}
          onRemove={() => {
            handleRemoveFile();
            handleHideRemoveFileModal();
          }}
        />
      )}
    </Container>
  );
}
